import { PhotosService } from "@/api";
import { useMutation } from "@tanstack/react-query";

export const useUploadPhoto = () => {
    const result = useMutation({
        mutationFn: ({ photos, childFrameId, isBackgroundReplacementOptOut, screenOrientation }: { photos: File[], childFrameId: string, isBackgroundReplacementOptOut?: boolean, screenOrientation?: string }) => PhotosService.photosControllerUploadPhoto({ photos, childFrameId, isBackgroundReplacementOptOut, screenOrientation }),
    });

    return result;
}